// Centralized External Supabase configuration.
// Reads values from Vite environment variables and validates at import time
// so misconfiguration fails loudly during build / app startup instead of
// surfacing as opaque runtime errors.

const url = import.meta.env.VITE_EXTERNAL_SUPABASE_URL;
const anonKey = import.meta.env.VITE_EXTERNAL_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    '[externalSupabase] Missing required environment variables: ' +
      'VITE_EXTERNAL_SUPABASE_URL and/or VITE_EXTERNAL_SUPABASE_ANON_KEY. ' +
      'Ensure both are defined in your .env before building or running the app.'
  );
}

export const EXTERNAL_SUPABASE_URL: string = url;
export const EXTERNAL_SUPABASE_ANON_KEY: string = anonKey;